import styled from '@emotion/styled'

const Container = styled.button`
  & {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
`

export default Container
